import { useEffect, useState } from "react";
import { Container, AllManageStateContainer, Cart, AllManageStateContainerPrecookingSetup } from "./style";
import Button from "components/particles/primary-button";
import AddPrecookingSetupPopup from "components/popus/Settings/precooking-setup";
import { usePrecookingSetups } from "./useHook";
import { useSelector } from "react-redux";
import { dispatch, RootState } from "store";
import { setModalOpened } from "store/user-slice";

export default function PrecookingSetup() {
  const [data, setData] = useState<any>(null);
  const [dataById, setDataById] = useState<any>();
  const [id, setId] = useState<number>(0);
  const { getPrecookingSetups } = usePrecookingSetups();
  const { precookingSetupModalIsOpen } = useSelector(
    (state: RootState) => state.user
  );

  useEffect(() => {
    getPrecookingSetups(setData);
  }, []);

  // Only refresh data when modal closes (after successful save/update)
  useEffect(() => {
    if (!precookingSetupModalIsOpen) {
      // Small delay to ensure the API call completes before refreshing
      const timer = setTimeout(() => {
        getPrecookingSetups(setData);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [precookingSetupModalIsOpen]);

  const handlePopup = (id: number) => {
    setId(id);
    dispatch(setModalOpened("Precooking Setup"));
    if (id) {
      setDataById(data);
    }
  };

  return (
    <Container>
      <div className="title">
        <h1>Precooking Setup Management</h1>
        {!data || !data.preCookingSetUp ? (
          <Button
            title="Add Precooking Setup"
            width="22rem"
            fill="true"
            backgroundcolor="var(--secondary)"
            onclick={() => handlePopup(0)}
          />
        ) : null}
      </div>

      <AllManageStateContainerPrecookingSetup>
        {data && data.preCookingSetUp ? (
          <Cart className="ql-editor">
            <div className="banner-img-title">
              <div className="banner-title">
                <h1>Precooking Setup</h1>
                <div
                  dangerouslySetInnerHTML={{ __html: data.preCookingSetUp }}
                />
              </div>
            </div>
            <Button
              title="Update"
              width="16rem"
              fill="true"
              onclick={() => handlePopup(1)}
              backgroundcolor="var(--secondary)"
            />
          </Cart>
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '4rem 2rem',
            width: '100%',
            backgroundColor: 'var(--white)',
            borderRadius: '1rem',
            boxShadow: '0 0.2rem 1rem rgba(0, 0, 0, 0.1)',
            border: '0.1rem solid var(--border)',
            margin: '2rem 0',
            gridColumn: '1 / -1',
            minHeight: '20rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <p style={{
              fontSize: '1.8rem',
              color: 'var(--text-secondary)',
              margin: 0,
              lineHeight: '1.6',
              maxWidth: '60rem'
            }}>
              No precooking setup found. Click "Add Precooking Setup" to create.
            </p>
          </div>
        )}
      </AllManageStateContainerPrecookingSetup>
      {precookingSetupModalIsOpen ? (
        <AddPrecookingSetupPopup id={id} data={dataById} />
      ) : (
        ""
      )}
    </Container>
  );
}
